import { UtilityService } from "src/app/core/services";
import { MessageService } from "primeng/api";
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { AuthData } from "../core/data";
import { LoginRequest } from "../core/models";
import { LocalStorageService } from "../core/services/shared-services/local-storage.service";
import { MenuService } from "../app.menu.service";
import { environment} from "src/environments/environment";
import { TranslocoService } from "@ngneat/transloco";
import { GtmService, GtmEventName, GtmLoginMethod, GtmUserType } from "../core/services/shared-services/gtm.service";
@Component({
    selector: "app-login",
    templateUrl: "./app.login.component.html",
    styleUrls: ["./app.login.component.scss"],
    standalone: false
})
export class AppLoginComponent {
    public loginForm: FormGroup;
    private returnUrl: string;
    disableLoginButton: boolean = false;
    userEmail:string="";
    userName:string="";
    showSubmitButtonLoader = false;
    env: any;
    latestYear: number = new Date().getFullYear();

    constructor(
        public app: AppComponent,
        private authServiceApi: AuthData,
        private route: ActivatedRoute,
        private router: Router,
        private messageService: MessageService,
        private utilityService: UtilityService,
        private localStorageService: LocalStorageService,
        private translocoService: TranslocoService,
        private menuService:MenuService,
        private gtm: GtmService
    ) {
        this.env = environment;
        this.loginForm = new FormGroup({
            email: new FormControl("", [Validators.required]),
            password: new FormControl("", [Validators.required]),
        });

        if (this.localStorageService.getItem("user") != null) {
            const userRole = this.authServiceApi.getRole();
            if (userRole?.toLowerCase() == "admin") {
                this.router.navigate(["/admin/dashboard"]);
            } else {
                this.router.navigate(["/selfcare/dashboard"]);
            }
        }
    }
    ngOnInit() {
        this.disableLoginButton = false;
        this.showSubmitButtonLoader = false;
        this.gtm.push({ event: GtmEventName.LoginStarted });
        this.route.queryParams.subscribe((params) => {
            this.returnUrl = params.returnUrl;
        });
    }

    submit() {
        if (this.loginForm.valid) {
            const loginReq: LoginRequest = {
                userName: this.formValues().email,
                password: this.formValues().password,
                language: this.translocoService.getActiveLang(),
                loginWithAD: false
            };
            
            this.showSubmitButtonLoader = true;
            this.disableLoginButton = true;
            this.authServiceApi.login(loginReq).subscribe({
                next: (v) => {
                    if(v.data !== null && v.data?.twoFactorEnabled) {
                        this.messageService.add({severity: 'info', summary: 'Success', detail: 'OTP Sent on email or sms'});                      
                        this.router.navigate(["/otp"],  {
                            state: {
                              UserId: v.data.id   // pass the user id to otp component
                            }
                        });
                       
                    }
                    else if(v.data !==  null && v.data?.isPasswordExpired && v.data?.resetLink !== "") {
                        const queryParams =  {
                            token: v.data?.resetLink
                          };
                        this.router.navigate(['reset'], {queryParams});
                    }
                    else {
                        this.userEmail=v?.data?.userName
                        let data={
                            uesrName:this.userName,
                            userEmail:this.userEmail
                        }
                        this.utilityService.userInformation(data)
                        if (v != null && v.success == true && v.data != null) {
                            this.gtm.push({
                                event: GtmEventName.LoginSuccess,
                                method: GtmLoginMethod.EmailPassword,
                                user_type: this.resolveUserType(v.data.role),
                            });
                            if(v.data?.isFirstLogin) {
                                this.messageService.add({
                                  severity: 'info',
                                  summary: 'Success',
                                });
                              }
                            if(v.data?.isPasswordAboutToExpire && !v.data?.isFirstLogin) {
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Success",
                                    detail: "Your password is about to expire, please reset your password.",
                                    life: 10000,
                                });
                            }
                            if (!this.authServiceApi.isLoggedIn()) {
                                this.localStorageService.setItem("user" ,
                                    JSON.stringify(v.data)
                                );
    
                                let registerDevice = {
                                    device_id: localStorage.getItem("device_id"),
                                    user_identity: v.data.id,
                                };
                                if (registerDevice.device_id) {
                                    this.utilityService
                                        .registerdevice(registerDevice)
                                        .subscribe({
                                            next: (r) => { },
                                        });
                                }
                                if (
                                    v.data.role?.toLowerCase() == "admin" ||
                                    v.data.role?.toLowerCase() == "tms" ||
                                    v.data.role?.toLowerCase() == "cms"
                                ) {
                                    this.router.navigate(["admin"]);
                                } else if (v.data.role?.toLowerCase() == "sales agent" ) {
                                    this.router.navigate(["sales-agent"]);
                                }
                                else if (v.data.role?.toLowerCase() == "enterprise sim") {
                                    this.router.navigate(["enterprise-sim"]);
                                } else {
                                    if (this.authServiceApi.isSelfCareUser()) {
                                        this.router.navigate(["selfcare"]);
                                    } else {
                                        localStorage.clear();
                                        this.pushLoginFailure();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Error",
                                            detail: "Invalid username/password. User is not register in selfcare.",
                                            life: 10000,
                                        });
                                    }
                                }
                            }
                            this.authServiceApi.isLoggedIn$.next(true);
                        }
                        else {
                            this.disableLoginButton = false;
                            this.showSubmitButtonLoader = false;
                            this.pushLoginFailure();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: v?.responseMessage_en ?? "Invalid username or password.",
                            });
                        }
                    }
                   
                },
                error: (e) => {
                    this.showSubmitButtonLoader = false;
                    this.disableLoginButton = false;
                    this.pushLoginFailure();
                },
            });
        }
    }

    loginWithAD() {
        localStorage.setItem('Attempt', "true")
        this.router.navigate(['/getting-ready']);
      }

    showPassword: boolean = false;
    showHide() {
        this.showPassword = !this.showPassword;
    }

    private pushLoginFailure(): void {
        this.gtm.push({
            event: GtmEventName.LoginFailure,
            method: GtmLoginMethod.EmailPassword,
        });
    }

    private resolveUserType(role: string): typeof GtmUserType[keyof typeof GtmUserType] {
        const r = role?.toLowerCase() ?? '';
        if (r === 'admin' || r === 'tms' || r === 'cms' || r === 'selfcare admin') return GtmUserType.SmeAdmin;
        if (r === 'shared access') return GtmUserType.SharedAccess;
        if (r === 'sales agent') return GtmUserType.SalesAgent;
        return GtmUserType.SmeUser;
    }

    formValues() {
        return this.loginForm.value;
    }
}
